import { z } from "zod";

const TRANSLATION_PATH = "page.settings.quickAnswer.errors.";

const shareTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: TRANSLATION_PATH + "share_type" }
);

const userSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const ticketWorkspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

const ticketChannelSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().nullish(),
});

export const quickAnswerSchema = z
  .object({
    id: z.string().optional(),
    title: z
      .string()
      .trim()
      .min(1, TRANSLATION_PATH + "title"),
    message: z
      .string()
      .trim()
      .min(1, TRANSLATION_PATH + "message"),
    shortCut: z
      .string()
      .trim()
      .min(1, TRANSLATION_PATH + "shortcut"),
    shareType: shareTypeSchema,
    user: userSchema.nullish(),
    ticketWorkspace: ticketWorkspaceSchema.nullish(),
    ticketChannel: ticketChannelSchema.nullish(),
  })
  .superRefine((val, ctx) => {
    switch (val.shareType && val.shareType.code) {
      case "1":
        if (!val.user) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: TRANSLATION_PATH + "user",
            path: ["user"],
          });
        }
        break;
      case "2":
        if (!val.ticketWorkspace) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: TRANSLATION_PATH + "ticket_workspace",
            path: ["ticketWorkspace"],
          });
        }
        break;
      case "3":
        if (!val.ticketChannel) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: TRANSLATION_PATH + "ticket_channel",
            path: ["ticketChannel"],
          });
        }
        break;
    }
  });

export type TQuickAnswerForm = z.infer<typeof quickAnswerSchema>;
